import { Controller } from "@hotwired/stimulus"

// Disables the submit button until all required fields are populated
// and the required checkbox is checked.
//
// Usage:
//   <form data-controller="form-validation" data-action="input->form-validation#validate change->form-validation#validate">
//     <input required data-form-validation-target="field">
//     <input type="checkbox" required data-form-validation-target="field">
//     <textarea required data-form-validation-target="field"></textarea>
//     <button type="submit" data-form-validation-target="submit" disabled>Submit</button>
//   </form>
export default class extends Controller {
  static targets = ["field", "submit"]

  connect() {
    this.validate()
  }

  validate() {
    const allValid = this.fieldTargets.every((field) => {
      if (field.type === "checkbox") {
        return field.checked
      }
      return field.value.trim().length > 0
    })

    this.submitTargets.forEach((btn) => {
      btn.disabled = !allValid
    })
  }
}
